<template>
  <input :id="field.name"
         :name="field.name"
         :data-vv-as="field.description.replace(/\./g, '')"
         class="form-control"
         v-validate="validators"
         v-mask="'XXX-XXX-XXXX'"
         :readonly="locked"
         :value="value"
         @input="input"
         @keypress="isNumber($event)"
  />
</template>

<script>
import { computed } from "vue";
import { mask } from 'vue-the-mask'

export default {
  props: {
    value: {
      type: String,
      required: false
    },
    field: {
      type: Object,
      required: true
    },
    required: {
      type: Boolean,
      default: false,
    },
    locked: {
      type: Boolean,
      default: false,
    }
  },
  directives: {mask},

  emits: ['input'],

  setup(props, { emit }) {
    const input = (e) => {
      emit('input', e.target.value.replace())
    }

    const validators = computed(() => {
      return {
        required: props.required && !props.field.hide,
      }
    })

    const isNumber = (e) => {
      let charCode = (e.which) ? e.which : e.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        e.preventDefault();
      } else {
        return true;
      }
    }

    return {
      validators,
      input,
      isNumber
    }
  }
}
</script>



// WEBPACK FOOTER //
// PhoneRender.vue?ef224eae